import React from 'react';
import styled from 'styled-components';

import { ActionButton } from '../../Button';
import Heading from '../../Heading';
import { Logout } from 'src/commons/utilities/identity';
import { pxToRem } from 'src/commons/utilities/utility';

const IdentityErrorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: ${pxToRem(8)} 0 0;
`;
IdentityErrorContainer.displayName = 'IdentityErrorContainer';

const IdentityHeading = styled(Heading)`
  padding-bottom: ${pxToRem(32)};
`;
IdentityHeading.displayName = 'IdentityHeading';

const ActionButtonWrapper = styled(ActionButton)`
  padding: 0 ${pxToRem(48)};
`;

const IdentityError = () => {
  const handleClick = () => {
    Logout();
  };
  return (
    <IdentityErrorContainer>
      <IdentityHeading>
        We were unable to verify
        <br />
        your information
      </IdentityHeading>
      <ActionButtonWrapper onClick={handleClick}>
        Log out and use new email
      </ActionButtonWrapper>
    </IdentityErrorContainer>
  );
};

export default IdentityError;
